import { render, staticRenderFns } from "./newwallet.vue?vue&type=template&id=6e7f69ea&"
import script from "./newwallet.vue?vue&type=script&lang=js&"
export * from "./newwallet.vue?vue&type=script&lang=js&"
import style0 from "./newwallet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports